import React from "react";

const IconNavArrowRight = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			width="18px"
			height="18px"
			stroke-width="1.7"
		>
			<path
				d="M9 6l6 6-6 6"
				stroke-linecap="round"
				stroke-linejoin="round"
			></path>
		</svg>
	);
};

export default IconNavArrowRight;
